
/**
 * 职业病
 */
 export const OccupationDiseaseList=[
    {
        prop:"id",
        label:"id",
        width:"150",
        isShow:false
    },
    {
        prop:"code",
        label:"代码",
        width:"150",
        isShow:true
    },
    {
        prop:"name",
        label:"名称",
        width:"150",
        isShow:true
    },
    {
        prop:"remark",
        label:"简述",
        width:"150",
        isShow:true
    }
 ]



